import React from 'react';
import { formatTimeScope } from '../services/projectsAPI';

/**
 * 時間範圍顯示元件
 * @param {Object} props
 * @param {Object} props.timeScope - 時間範圍物件
 * @param {boolean} props.showIcon - 是否顯示圖示
 * @param {string} props.className - 額外的 CSS 類別
 */
function TimeScopeDisplay({ timeScope, showIcon = true, className = '' }) {
  if (!timeScope) return null;

  const formattedScope = formatTimeScope(timeScope);

  return (
    <span className={`inline-flex items-center text-sm text-gray-600 ${className}`}>
      {showIcon && (
        <svg
          className="w-4 h-4 mr-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      )}
      {formattedScope}
    </span>
  );
}

export default TimeScopeDisplay;
